import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { initializeAPI } from "../../api/axios";

const LOGIN_URL = "/clientportalaccount/login";

const AutoLogin = () => {
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const { base64data } = useParams();
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    const autoLogin = async () => {
      if (base64data) {
        try {
          const decodedData = atob(base64data);
          const loginCredentials = JSON.parse(decodedData);

          // Initializing the API instance
          const api = initializeAPI();
          const response = await api.post(LOGIN_URL, {
            username: loginCredentials.Username,
            password: loginCredentials.Password,
            clientCode: loginCredentials.ClientCode,
            region: loginCredentials.Region,
          });

          const accessToken = response?.data?.data?.access_token;

          if (accessToken) {
            setAuth({ accessToken });
            localStorage.setItem("accessToken", accessToken);
            initializeAPI();
          } else {
            throw new Error("No access token returned.");
          }

          const state = loginCredentials.MatterId
            ? { state: { matterId: loginCredentials.MatterId } }
            : {};
          navigate("/dashboard", { ...state, replace: true });
        } catch (error) {
          setErrMsg("Login failed. Please try again.");
          console.error("Error during auto-login:", error);
          navigate("/login", { replace: true });
        }
      } else {
        setErrMsg("Invalid login data.");
        setLoading(false);
      }
    };

    autoLogin();
  }, [base64data]);

  return <div>{errMsg ? <p>{errMsg}</p> : <p>Loading...</p>}</div>;
};

export default AutoLogin;
